import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const NotesOutlineIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6475 4.34961C19.0288 4.34983 20.1502 5.47119 20.1504 6.85254V14.8525C20.1504 15.5954 19.8914 16.2278 19.4189 16.7002L16.21 19.9092C15.7516 20.3675 15.1407 20.6244 14.4902 20.6377C14.4724 20.6449 14.453 20.6504 14.4326 20.6504H6.35254C4.97119 20.6502 3.84983 19.5288 3.84961 18.1475V6.85254C3.84983 5.47119 4.97119 4.34983 6.35254 4.34961H17.6475ZM6.35254 5.59082C5.65453 5.59104 5.09104 6.15453 5.09082 6.85254V18.1475C5.09104 18.8455 5.65453 19.409 6.35254 19.4092H14.3525C14.7691 19.4092 15.0969 19.2711 15.3291 19.0391L18.5391 15.8291C18.7742 15.5938 18.9092 15.2647 18.9092 14.9375V6.85254C18.909 6.15453 18.3455 5.59104 17.6475 5.59082H6.35254Z"
        fill={iconColor}
        stroke={iconColor}
        strokeWidth="0.3"
      />
      <path
        d="M17.1765 8.27417H7.03058V9.44123H17.1765V8.27417Z"
        fill={iconColor}
      />
      <path
        d="M19.4439 13.9402V15.1814H14.9742L14.9732 15.1824V20.1794H13.732V15.1824C13.732 14.4972 14.289 13.9402 14.9742 13.9402H19.4439Z"
        fill={iconColor}
        stroke={iconColor}
        strokeWidth="0.3"
      />
    </Box>
  );
};
